// Permission constants (same pattern as Currency module - login-based access)
export const PERMISSIONS = {
    FEATURE_CATEGORY: {
        VIEW: 'feature_category_view',
        CREATE: 'feature_category_create',
        EDIT: 'feature_category_edit',
        DELETE: 'feature_category_delete'
    },
    CAR_FEATURE: {
        VIEW: 'car_feature_view',
        CREATE: 'car_feature_create',
        EDIT: 'car_feature_edit',
        DELETE: 'car_feature_delete'
    }
};

// Returns true when logged in (Currency module has no RBAC; extend when roles are added)
export const hasPermission = (permission, adminProfile) => {
    if (!adminProfile) {
        return true;
    }
    if (adminProfile.permissions && Array.isArray(adminProfile.permissions)) {
        return adminProfile.permissions.includes(permission);
    }
    return true;
};
